/** Preserve existing whitespace, including its absence, while editing a cue body. */
export function replaceCaptionWordBody(original:string,value:string):string{
  const leading=original.match(/^\s*/)?.[0]??'';
  const trailing=original.slice(leading.length).match(/\s*$/)?.[0]??'';
  return leading+value.trim()+trailing;
}
